import { defineMessages } from 'utils/intl';

export default defineMessages({
  heading: 'Filtry',
  clear: 'Wyczyść ({quantity})',
  from: 'od',
  to: 'do',
  advancedFilters: 'Filtry zaawansowane',
  productType: 'Typ produktu',
});
